/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "UpdateJobRequest": {
            "fields": {
              "jobId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "job": {
                "type": ".squareup.team_api.Job",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "UpdateJobResponse": {
            "fields": {
              "job": {
                "type": ".squareup.team_api.Job",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.UpdateJobRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.UpdateJobResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents an [UpdateJob](api-endpoint:Team-UpdateJob) request.
 * --
 *
 * SOURCE UpdateJobRequest @ squareup/team_api/endpoints/update-job.proto at 23:1
 */
export const UpdateJobRequest = $root.lookupType('squareup.team_api.UpdateJobRequest');
fixType(UpdateJobRequest, {
  jobId: {
    notEmpty: true
  },
  job: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateJobRequest);
/**
 * --
 * @desc Represents an [UpdateJob](api-endpoint:Team-UpdateJob) response. Either `job` or `errors`
 * is present in the response.
 * --
 *
 * SOURCE UpdateJobResponse @ squareup/team_api/endpoints/update-job.proto at 45:1
 */
export const UpdateJobResponse = $root.lookupType('squareup.team_api.UpdateJobResponse');
fixType(UpdateJobResponse);
Builder.createAndAttachToType(UpdateJobResponse);